
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zespol",
      function () {
        return require("private-next-pages/zespol.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zespol"])
      });
    }
  